import { bootstrapApplication } from '@angular/platform-browser';
import esriConfig from '@arcgis/core/config.js';
import { appConfig } from './app/app.config';
import { AppEnvironment } from './app/config/app-environment';
import { AppComponent } from './app/app.component';
import { registerCalciteComponents } from './app/config/calcite';

esriConfig.assetsPath = AppEnvironment.arcgisAssetsBaseUrl;
registerCalciteComponents();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
